import { Badge } from "@/components/ui/badge";
import { STATUS } from "./calendarUtils";

export const StatusBadge = ({ status, testid }) => {
  const s = STATUS[status] || STATUS.regular;
  return <Badge data-testid={testid} className={`border-0 shrink-0 ${s.c}`}>{s.l}</Badge>;
};
